import CreateListResourceInteractor from "../../core/interactor/app/crud/CreateListResourceInteractor";
import Constants from "../common/Constants";
import { ICourtCase } from "../model/CourtCase";

export default class AddCourtCasesToCaseLawDocumentInteractor {
  private createListResource: CreateListResourceInteractor<ICourtCase>;

  constructor({ createListResource }: any) {
    this.createListResource = createListResource;
  }

  async execute(courtCaseList: ICourtCase[], caseLawDocumentId: number) {
    return this.createListResource.execute(
      Constants.courtCaseLawDocumentPath,
      courtCaseList,
      { query: { caseLawDocumentId } }
    );
  }
}
